import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@/components/Button/Button";
import styles from "./DineWithFounders.module.scss";
import BackgroundTexture from "@/assets/svg/backgroudTextureSvg";

const DineWithFounders = () => {
  const navigate = useNavigate();
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleContinue = async () => {
    navigate("/how-it-works")
  };

  return (
    <section aria-labelledby="dine-with-founders-title" className={styles.page}>
      <div className={styles.heroImage}>
        <img
          alt="Founders sharing dinner together"
          className={`${styles.heroPhoto} ${imageLoaded ? styles.heroPhotoLoaded : ""}`}
          onLoad={() => setImageLoaded(true)}
          src="/dineWithFounders.jpg"
        />
        <div aria-hidden="true" className={styles.heroFade} />
      </div>

      <div className={styles.content}>
        <BackgroundTexture className={styles.backgroundTextureTop} />
        <BackgroundTexture className={styles.backgroundTextureBottom} />

        <img alt="BFC" className={styles.logo} src="/BFClogo.png" />

        <h1 className={styles.title} id="dine-with-founders-title">
          Dine with Founders
        </h1>

        <p className={styles.tagline}>No profiles. No pitches. Just dinner.</p>

        <p className={styles.description}>
          Meet another founder over a curated dinner. Real conversations, without
          expectations.
        </p>

        <Button
          className={styles.continueButton}
          onClick={handleContinue}
          type="button"
        >
          Continue
        </Button>
      </div>
    </section>
  );
};

export default DineWithFounders;
